import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/custom/button";
import { PiUpload } from "react-icons/pi";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { UploadSitesDialog } from "./-upload-sites-dialog";

export const UploadSites = () => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="flex gap-1 justify-around">
          <PiUpload className="w-4 h-4" />
          {t("uploadAFile")}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <VisuallyHidden>
          <DialogTitle>{t("Upload Sites CSV")}</DialogTitle>
          <DialogDescription>
            {t("Upload your sites CSV file")}
          </DialogDescription>
        </VisuallyHidden>
        {open && <UploadSitesDialog onClose={() => setOpen(false)} />}
      </DialogContent>
    </Dialog>
  );
};
